export default __webpack_public_path__ + "static/media/icon_copy.45d18041.svg";